import { useParams } from 'react-router-dom';

import { useGetPatientLastAppointmentSharedAVS } from '@grow-therapy-team/seedling-components';

import { useGetAuthedAtTimestamp } from '../auth/useGetAuthedAtTimestamp';

/**
 * Whether the client should see their shared AVS. They have to have one.
 */
export function useGetShouldShowPatientAVS() {
  const [authedAtTimestamp] = useGetAuthedAtTimestamp();

  const { patientShortId } = useParams();
  const { appointmentWithSharedAVS, loading: isLoading } = useGetPatientLastAppointmentSharedAVS(
    patientShortId ?? '',
    !authedAtTimestamp,
  );
  const hasAVS = !!appointmentWithSharedAVS?.patientAfterVisitSummary?.afterVisitSummary;

  return { isLoading, shouldShowPatientAVS: !isLoading && hasAVS };
}
